import { render, staticRenderFns } from "./DieuKhoan.vue?vue&type=template&id=4fc18732&scoped=true&"
import script from "./DieuKhoan.vue?vue&type=script&lang=js&"
export * from "./DieuKhoan.vue?vue&type=script&lang=js&"
import style0 from "./DieuKhoan.vue?vue&type=style&index=0&id=4fc18732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc18732",
  null
  
)

export default component.exports